// The function receives getters instead of elements so that it can be called during the initial render
export var syncedHandlers = function (getScrollElements) {
    var currentlyScrolled = -1;
    return getScrollElements.map(function (elementGetter, index) { return function () {
        // prevent running the handler on the synced elements
        if (currentlyScrolled === -1 || currentlyScrolled === index) {
            requestAnimationFrame(function () {
                currentlyScrolled = index;
                var element = elementGetter();
                if (element) {
                    var scrollLeft_1 = element.scrollLeft;
                    getScrollElements.forEach(function (syncedElementGetter) {
                        var syncedElement = syncedElementGetter();
                        if (syncedElement) {
                            // In case the element is currently not displayed, this saves the scroll value for later retrieval.
                            syncedElement.setAttribute('data-scroll-left', scrollLeft_1.toString());
                            if (syncedElement !== element) {
                                syncedElement.scrollLeft = scrollLeft_1;
                            }
                        }
                    });
                }
                // unblock the ability to scroll the synced elements
                requestAnimationFrame(function () {
                    currentlyScrolled = -1;
                });
            });
        }
    }; });
};
//# sourceMappingURL=sync-scroll.js.map